module.exports = __webpack_public_path__ + "static/media/noun-wifi-1254486-808080.0e490345.svg";